export { DealerServiceCard } from './dealer-service-card'
export type { DealerServiceCardProps } from './dealer-service-card.types'
